import { Link } from "gatsby";
import * as React from "react";
import { forwardRef, PropsWithChildren } from "react";

// import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";
import Markdown from "../Markdown/Markdown";
import { getHtmlFromString } from "../shared/utils/createTitle";
import { Column } from "./column-gql";

type PropsColumn = PropsWithChildren<{
  data: Column;
  settings: { area?: "column-1" | "column-2" | "column-3" | "column-4" | "column-5"; isNested?: boolean };
}>;

const ColumnArea = forwardRef<HTMLDivElement, PropsColumn>((props, ref) => {
  // if (!props.data) return <DoNotMountComponent sms={"Column"} log={props} />;
  if (!props.data) return <div className={`m-column ${props.settings.area}`}> {props.settings.area}</div>;
  const { data } = props;
  return (
    <div ref={ref} className={`${props.settings.isNested ? "" : `m-column ${props.settings.area}`} `}>
      <div className={`${props.settings.isNested ? "column__row-headline" : "column__headline"}`}>
        {data.content ? (
          <Link
            className={"column__item column__item--th column__item--red"}
            to={data.slug === "informacion" ? "" : `/${data.slug}/`}
          >
            {data?.summary?.title ? (
              <Markdown props={{ className: "column__title" }} markdown={data?.summary?.title} />
            ) : (
              data.name
            )}
            {data?.summary?.text && (
              <Markdown props={{ className: "column__subtitle" }} markdown={data?.summary.text} />
            )}
          </Link>
        ) : (
          <div className={"column__item column__item--th column__item--red non-clickable"}>
            {data?.summary?.title ? (
              <Markdown props={{ className: "column__title" }} markdown={data?.summary?.title} />
            ) : (
              data.name
            )}
            {data?.summary?.text && (
              <Markdown props={{ className: "column__subtitle" }} markdown={data?.summary.text} />
            )}
          </div>
        )}
      </div>
      <ul className={"column__list"}>
        {data?.singleRow?.map((item, index) => (
          <li key={index}>
            <Link
              className={"column__item"}
              activeClassName={"column__item--active"}
              to={`/${data.slug}/${item.slug}/`}
            >
              {" "}
              {item.name}
            </Link>
          </li>
        ))}
        {data?.multiRow?.map((item, index) => (
          <li key={index} className={"column__multi-item"}>
            {item.name === "Estatuto de Aragón" ? (
              <span className={"column__item column__item--th"}>{item.name}</span>
            ) : (
              <Link className={"column__item column__item--th"} to={`/${data.slug}/${item.slug}/`}>
                {item.name}
              </Link>
            )}
            {item?.description && <Markdown className={"n/a"} markdown={item.description} />}
            {item?.singleRow.length > 0 && (
              <ul className={"column__list"}>
                {item?.singleRow?.map((subitem, index) => (
                  <li key={index}>
                    <Link
                      className={"column__item"}
                      activeClassName={"column__item--active"}
                      to={`/${data.slug}/${item.slug}/${subitem.slug}/`}
                    >
                      {getHtmlFromString(subitem.name)}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
      {props.children}
    </div>
  );
});

ColumnArea.displayName = "ColumnArea";

export default ColumnArea;
